import React from "react";

import { Carousel } from "react-bootstrap";

function importAll(r) {
	let images = {};
	r.keys().map(item => {
		images[item.replace("./", "")] = r(item);
	});
	return images;
}

const commercialImages = importAll(require.context("../../public/images/commercial", false, /\.(png|jpe?g|svg)$/));
const remodelImages = importAll(require.context("../../public/images/remodels", false, /\.(png|jpe?g|svg)$/));
const images = { ...commercialImages, ...remodelImages };

const CarouselCom = props => {
	return (
		<Carousel id="carcom" wrap={false}>
			{props.images !== ""
				? props.images.map((img, idx) => {
						return (
							<Carousel.Item>
								<img className="d-block w-100" src={images[img]} alt="carousel slide" />
							</Carousel.Item>
						);
				  })
				: "Loading..."}
		</Carousel>
	);
};

export default CarouselCom;
